import type { PatchedTripWritable } from '@bambi/api-client/schemas';
import type { UseFormGetFieldState } from 'react-hook-form';

import type { AddTripFormValues } from '../FormValues';
import { buildExistingTripPayload } from './adaptFormValuesHelpers';

export const adaptFormValuesToUpdate = (
  formValues: AddTripFormValues,
  getFieldState: UseFormGetFieldState<AddTripFormValues>
): PatchedTripWritable => {
  const tripUpdate: PatchedTripWritable = buildExistingTripPayload(
    formValues.trips[0],
    formValues
  );

  // Check dirty on the following fields so as to not cause a recalculation
  // pickup, dropoff, scheduled_pickup_at

  if (!getFieldState('trips.0.pickupLocation').isDirty) {
    delete tripUpdate.pickup;
  }

  if (!getFieldState('trips.0.dropoffLocation').isDirty) {
    delete tripUpdate.dropoff;
  }

  if (
    !getFieldState('trips.0.timing.date').isDirty &&
    !getFieldState('trips.0.timing.pickup_time').isDirty
  ) {
    delete tripUpdate.scheduled_pickup_at;
  }

  return tripUpdate;
};
